import React, { Component, Fragment } from "react";
import { Row, Col } from 'react-bootstrap';
import { Modal } from "react-bootstrap";
import autoBind from "react-autobind";
import { ddados } from "../consultarProtocolo.ddados";
import DDadosItem from '@common/components/ddados/ddados.item';
import { connect } from "@common/components/base.component";
import consultarProtocoloSelector from "../store/consultarProtocolo.selectors";
import consultarProtocoloActions from "../store/consultarProtocolo.actions";
import Form from "@common/externos/components/validation/form.validation";
import RecaptchaModal from "react-recaptcha";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  verifyCallback(response) {
    this.props.consultarProtocoloActions.setTokenRecaptchaModal(response);
  }

  expiredCallback() {
    this.props.consultarProtocoloActions.setTokenRecaptchaModal("");
  }

  recaptchaRef(ref){
    this.props.consultarProtocoloActions.setRecaptchaResetRefModal(ref?.reset);
  }

  onSubmit(data) {
    this.props.consultarProtocoloActions.pesquisarConsultarProtocoloModal(data.CpfCnpj);
  }

  toggleModal() {
    this.props.consultarProtocoloActions.toggleModalConsultarProtocolo();
  }

  render() {
    const { Campos, Titulo } = ddados;
    const { verifyCallback, expiredCallback, recaptchaRef, show } = this.props;


    return (
      <Modal
        className={"mt-5 mb-5"}
        show={show}
        onHide={this.toggleModal}
        enforceFocus={true}
        size="lg"
        backdrop="static"
      >
      <Form
      onSearchSubmit={this.onSubmit}
      onCancel={this.toggleModal}
      fromModal={true}
    >
      {form => (
        <div elementID='2'>
        <Modal.Header>
          <Modal.Title>
            <h3>Consultar Protocolo</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Row>
          <Col>
            <DDadosItem name="CpfCnpj" {...Campos.CpfCnpj}/>
          </Col>
        </Row>
        <Row>
          <Col xs={12} lg={4}>
             <RecaptchaModal
               elementID='2'
               ref={this.recaptchaRef}
               sitekey={"6LeSHQETAAAAACjgu00LxcbscsmkkwMIqhfd1-Gh"}
               verifyCallback={this.verifyCallback}
               render={"explicit"}
               expiredCallback={this.expiredCallback}
               hl="pt-br"
               theme="light"
               size="normal"
              />
          </Col>
        </Row>
        </Modal.Body>
        </div>
      )}
      </Form>
      </Modal>
    );
  }
}

export default connect({
  actions: {
    consultarProtocoloActions
  },
  selectors: {
    consultarProtocoloSelector
  }
})(Container);
